import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';
import * as Sentry from '@sentry/react';
import App from './App';
import './styles.css';

Sentry.init({
  dsn: 'https://7c6fcccbfd4c4eec8d716999c5099118@o4511422372773888.ingest.us.sentry.io/4511422380244992',
  environment: import.meta.env.MODE,
  release: __APP_VERSION__,
  sendDefaultPii: true,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  // Exclui /functions/v1/: o Sentry injeta sentry-trace/baggage nos fetches
  // que casam aqui, e o CORS das edge functions (Access-Control-Allow-Headers
  // fixo) reprova o preflight → "Load failed" em TODA chamada de função do
  // navegador (export PDF, checkout, admin). O gateway do REST aceita os
  // headers, então REST/auth/storage seguem com tracing.
  tracePropagationTargets: ['localhost', /^https:\/\/.*\.supabase\.co\/(?!functions\/v1\/)/],
  replaysSessionSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
});

const root = createRoot(document.getElementById('root')!);
root.render(<App />);
